module.exports = __webpack_public_path__ + "static/The_Cotswolds-820a687ec2a4c6e2161464ef24adeaab.jpeg";